import { render, staticRenderFns } from "./EcommerceRecentOrders.vue?vue&type=template&id=72d9e1cc&"
import script from "./EcommerceRecentOrders.vue?vue&type=script&lang=js&"
export * from "./EcommerceRecentOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports